import { Routes } from '@angular/router';
import { ArticlesComponent } from './articles/articles.component';
import { ArticleDetailsComponent } from './articles/article-details/article-details.component';

export const MOBILE_ROUTES: Routes = [
    { path: '', component: ArticlesComponent, children: [
        { path: ':akey', component: ArticleDetailsComponent }
    ] },
];



// WEBPACK FOOTER //
// ./src/app/mobile/mobile.routes.ts